function initAccordion() {
  const items = document.querySelectorAll(".accordion button");

  function toggleAccordion(event) {
    const current = event.currentTarget;
    const isExpanded = current.getAttribute("aria-expanded") === "true";

    for (const item of items) {
      item.setAttribute("aria-expanded", "false");
    }

    if (!isExpanded) {
      current.setAttribute("aria-expanded", "true");
    }
  }

  items.forEach(item => {
    item.addEventListener("click", toggleAccordion);
  });
}

function toggleSection() {
  const mobileSection = document.querySelector(
    ".footer--mobile"
  );
  const desktopSection = document.querySelector(
    ".footer--desktop"
  );

  if (!mobileSection || !desktopSection) return;

  if (window.innerWidth <= 780) {
    // мобильная версия
    mobileSection.style.display = "block";
    desktopSection.style.display = "none";
  } else {
    // десктоп версия
    mobileSection.style.display = "none";
    desktopSection.style.display = "block";
  }
}

toggleSection();
window.addEventListener("resize", toggleSection);

document.addEventListener("DOMContentLoaded", () => {
  initAccordion();
  tiggleSection();
});